import classNames from 'classnames/bind';
import styles from './faq.module.scss';
import { Accordion, Container, Title } from '@planity/ui';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useTranslation, useLocalization } from '@planity/localization';

export function Faq({
	translationKey = 'landing.newFaq',
	pageKey = 'landing'
}) {
	useStyles(styles);
	const { t } = useTranslation();
	const { locale } = useLocalization();

	const data = getData({ pageKey, translationKey, locale, t });

	const classes = classNames.bind(styles)({
		faq: true,
		hasGreyBackground: locale !== 'nl-BE' ? true : false
	});

	return (
		<div className={classes}>
			<Container size='small' noStupidMarginBottom>
				<Title
					label={t(`${pageKey}.subtitle.faq`)}
					title={t(`${pageKey}.headline.faq`)}
					align='center'
				/>

				<div className={styles.accordions}>
					{data &&
						Object.values(data).map(({ question, answer }, i) => (
							<Accordion key={i} title={question}>
								{Object.values(answer || {}).map((item, index) => (
									<p
										className={styles.answer}
										dangerouslySetInnerHTML={{ __html: item }}
										key={index}
									/>
								))}
							</Accordion>
						))}
				</div>
			</Container>
		</div>
	);
}

function getData({ pageKey, translationKey, locale, t }) {
	switch (pageKey) {
		case 'landing':
			return t(translationKey, {
				tel: t(
					`${pageKey}.FaqTel${
						locale === 'fr-BE' || locale === 'nl-BE' ? 'Bis' : 'Default'
					}`
				)
			});
		default:
			return t(translationKey);
	}
}
